export const EMPSTATUS = {
    None: "None",
    Parttime: "Part-Time",
    Fulltime: "Full-Time",
}